import { ICreateAccessorPayload } from '../types';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import AccessoryForm from '../components/AccessoryForm';
import { useCreateAccessor } from '../hooks/useCreateAccessor';

const initAccessor: ICreateAccessorPayload = {
  code: null,
  equipment: null,
  description: null,
  serial_number: null
};

export const AccessoryCreateView = () => {
  const translationPrefix = 'pages.accessories.new';
  const { t } = useTranslation();
  const { onSubmit } = useCreateAccessor();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <AccessoryForm accessor={initAccessor} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default AccessoryCreateView;
